


import { Icon } from "@iconify/react/dist/iconify.js";
// import axios from "axios";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import { BaseUrl } from "../helper/apiHelper";
import toast from "react-hot-toast";
import banner_img from "../assets/images/banner_img.webp"
import banner_img_2 from "../assets/images/banner_img_2.webp"
import banner_img_3 from "../assets/images/banner_img_3.webp"
import { signInAdminApi } from "../helper/apiHelper";

import logo_img from "../assets/images/logo_img.webp"
const SignInLayer = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // 👈 add this
  const [isLoading, setIsLoading] = useState(false)
  const handleSignInclick = async () => {
    try {
      if (!email) {
        toast.error("Please enter email");
        return;
      }
      if (!password) {
        toast.error("Please enter password");
        return;
      }

      setIsLoading(true);

      // if (email === "starlightvapes@gmail.com" && password === "Starlight@#$%") {
      //   localStorage.setItem("token", "dummy_token");
      //   localStorage.setItem("userData", JSON.stringify({ name: "Admin", email: "starlightvapes@gmail.com" }));
      //   navigate("/dashboard");
      //   return;
      // }

      const body = { email, password };
      const response = await signInAdminApi(body);

      if (response) {
        localStorage.setItem("token", response.accessToken);
        localStorage.setItem(
          "userData",
          JSON.stringify(response.userData)
        );
        toast.success("Login Successful!");
        navigate("/dashboard");
      }
    } catch (error) {
      // console.log(error)
      toast.error(error?.response?.data?.message || error?.message || error || "Login failed");
    } finally {
      setIsLoading(false); // 👈 Stop loading (whether success or fail)
    }
  };


  return (
    <section className="auth bg-base d-flex flex-wrap">
      <div className="auth-left d-lg-block d-none">
        <div className="d-flex align-items-center flex-column h-100 justify-content-center">
          <img src={banner_img} alt="" />
        </div>
      </div>
      <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
        <div className="max-w-464-px mx-auto w-100">
          <div>
            <Link to="/" className=" " style={{ maxWidth: "300px", marginBottom: "20px" }}>
              <img src={logo_img} alt="" />
            </Link>
            <h4 className="mb-12">Sign In to your Account</h4>
            <p className="mb-32 text-secondary-light text-lg">
              Welcome back! please enter your detail
            </p>
          </div>
          <form action="#">
            <div className="icon-field mb-16">
              <span className="icon top-50 translate-middle-y">
                <Icon icon="mage:email" />
              </span>
              <input
                type="email"
                className="form-control h-56-px bg-neutral-50 radius-12"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="position-relative mb-20">
              <div className="icon-field">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="solar:lock-password-outline" />
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control h-56-px bg-neutral-50 radius-12"
                  id="your-password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <span
                className="position-absolute end-0 top-50 translate-middle-y me-16 d-flex align-items-center cursor-pointer"
                style={{ height: "100%" }}
                onClick={() => setShowPassword(!showPassword)}
              >
                <Icon
                  icon={showPassword ? "mdi:eye-off" : "mdi:eye"}
                  width={24}
                  height={24}
                />
              </span>
            </div>
            {/* <div className="">
              <div className="d-flex justify-content-between gap-2">
                <div className="form-check style-check d-flex align-items-center">
                  <input
                    className="form-check-input border border-neutral-300"
                    type="checkbox"
                    id="remember"
                  />
                  <label className="form-check-label" htmlFor="remember">
                    Remember me
                  </label>
                </div>
              </div>
            </div> */}
            <button
              type="button"
              className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-10"
              onClick={handleSignInclick}
              disabled={isLoading} // prevent double clicks
            >
              {isLoading ? (
                <span>
                  <span className="spinner-border spinner-border-sm me-2" role="status" />
                  Signing In...
                </span>
              ) : (
                "Sign In"
              )}

            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default SignInLayer;
